
import { defineComponent } from "vue";

export default defineComponent({
  name: "VerticalMenu",
  props: {
    items: {
      type: Array as () => any[],
      default: () => [],
    },
  },
});
